import { IdentityField, TextFieldAdapter } from 'components/enhanced';
import { SectionHeader } from 'components/ui/typography';
import { ContractLine } from 'features/inventory/contracts/types';
import { useEffect, useState } from 'react';
import { useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { contractLineService } from 'shared/services';

export const OrderNotesField = ({ selectedContractLine }: { selectedContractLine: any }) => {
  const form = useForm();
  const { t } = useTranslation();
  const [initialValue, setInitialValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (selectedContractLine) {
      contractLineService.getSummary(selectedContractLine.id).then((res: ContractLine) => {
        const notes = res.order_notes || '';
        setInitialValue(notes);

        form.change('notes', notes);
      });
    } else {
      setInitialValue('');
      form.change('notes', '');
    }
  }, [selectedContractLine, form]);

  if (!selectedContractLine || initialValue === undefined) {
    return null;
  }

  return (
    <>
      <SectionHeader title={t(`pages.purchase-requests.new.other`)} gridSpan />

      <IdentityField
        gridSpan={2}
        name="notes"
        component={TextFieldAdapter}
        label={t('global.notes')}
        initialValue={initialValue}
        type="text"
        multiline
        rows={2}
      />
    </>
  );
};
